import { useContext, useMemo } from "react";
import { useToaster } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import { UserInfoStatusContext } from "./userInfoStatusContext";

/**
 * Reports a write's outcome in the page's live region **and** as a toast: `useToaster()` renders no
 * live region, so a toast alone is never spoken (`.claude/rules/accessibility.md`).
 *
 * Must be called inside `StatusRegion`, or the announcement goes to the context's no-op default.
 */
export const useWriteAnnouncer = () => {
  const announce = useContext(UserInfoStatusContext);
  const { toastError, toastSuccess } = useToaster();

  return useMemo(
    () => ({
      // Writes clear the region when they start, so a repeated identical outcome is still spoken.
      clear: () => announce(""),
      success: (labelKey: string) => {
        const text = Locale.getText(labelKey) as string;
        announce(text);
        toastSuccess(text, "");
      },
      failure: (text: string) => {
        announce(text);
        toastError(text);
      }
    }),
    [announce, toastError, toastSuccess]
  );
};
